/* سطر — global storefront behaviour */
(function () {
  'use strict';
  var A = window.Athar || {};

  // Notebook motion: scroll reveal, doodle drawing, pencil progress
  var root = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var targets = document.querySelectorAll('[data-reveal]');
  if (reduce || !('IntersectionObserver' in window)) {
    root.classList.add('no-reveal');
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    targets.forEach(function (t) { io.observe(t); });
    // Safety net: never leave content hidden
    setTimeout(function () { targets.forEach(function (t) { var r = t.getBoundingClientRect(); if (r.top < innerHeight) t.classList.add('is-in'); }); }, 1500);
  }
  var bar = document.querySelector('.pencil-progress');
  if (bar) {
    var ticking = false;
    var setP = function () {
      var h = document.documentElement.scrollHeight - innerHeight;
      bar.style.setProperty('--p', h > 0 ? Math.min(1, Math.max(0, scrollY / h)).toFixed(4) : 0);
      ticking = false;
    };
    addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(setP); } }, { passive: true });
    setP();
  }

  // Mobile nav
  var toggle = document.querySelector('[data-nav-toggle]');
  if (toggle) toggle.addEventListener('click', function () {
    var nav = document.getElementById(toggle.getAttribute('aria-controls'));
    var open = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!open));
    nav.classList.toggle('is-open', !open);
  });

  // Sort / facet auto-submit
  document.querySelectorAll('[data-autosubmit]').forEach(function (s) { s.addEventListener('change', function () { s.form.submit(); }); });
  document.querySelectorAll('[data-facet-form] [data-facet-input]').forEach(function (i) { i.addEventListener('change', function () { i.form.submit(); }); });

  // Product gallery
  var main = document.querySelector('[data-gallery-main]');
  document.querySelectorAll('[data-gallery-thumb]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (!main) return;
      main.removeAttribute('srcset');
      main.src = b.dataset.src; main.alt = b.dataset.alt;
      document.querySelectorAll('[data-gallery-thumb]').forEach(function (x) { x.removeAttribute('aria-current'); });
      b.setAttribute('aria-current', 'true');
    });
  });

  // Product: license variant + purchase mode
  var form = document.querySelector('[data-product-form]');
  if (form) {
    var idInput = form.querySelector('[data-variant-id]');
    form.querySelectorAll('[data-variant-radio]').forEach(function (r) {
      r.addEventListener('change', function () {
        idInput.value = r.value;
        var cur = form.querySelector('[data-price-current]');
        if (cur) cur.textContent = r.dataset.price;
        var cmp = form.querySelector('[data-price-compare]');
        if (cmp) cmp.hidden = !r.dataset.compare;
      });
    });
    var addBtn = form.querySelector('[data-add-digital]');
    var goPrint = form.querySelector('[data-go-print]');
    form.querySelectorAll('[data-mode]').forEach(function (r) {
      r.addEventListener('change', function () {
        var print = r.value === 'print' && r.checked;
        if (addBtn) addBtn.hidden = print;
        if (goPrint) goPrint.hidden = !print;
      });
    });
  }

  // Related products (Section Rendering API)
  var rec = document.querySelector('[data-recommendations]');
  if (rec && rec.dataset.url && !rec.children.length) {
    fetch(rec.dataset.url).then(function (r) { return r.text(); }).then(function (t) {
      var d = document.createElement('div'); d.innerHTML = t;
      var s = d.querySelector('[data-recommendations]');
      if (s && s.innerHTML.trim()) rec.innerHTML = s.innerHTML;
    }).catch(function () {});
  }

  // Cart: remove a line, and every other line of the same print job
  document.querySelectorAll('[data-remove-line]').forEach(function (b) {
    b.addEventListener('click', function () {
      b.disabled = true;
      fetch(A.routes.cartJs, { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
        var updates = {};
        updates[b.dataset.removeLine] = 0;
        if (b.dataset.job) cart.items.forEach(function (i) { if (i.properties && i.properties._athar_job === b.dataset.job) updates[i.key] = 0; });
        return fetch(A.routes.cartUpdate + '.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: updates }) });
      }).then(function () { location.reload(); }).catch(function () { b.disabled = false; });
    });
  });
})();
